import { useState, useMemo, useEffect } from 'react';
import { showToast } from '@global/design-system/molecules';

import checkIsGKAdmin from '@app/utils/checkIsGKAdmin';
import { WORKSPACE_INDICATOR_TOAST_FIELD } from './constants';

import { WorkspaceIndicatorToastProps } from './types';

export default function WorkspaceIndicatorToast({
	userEmail,
	organizationName,
}: WorkspaceIndicatorToastProps) {
	const [isManuallyClosed, setIsManuallyClosed] = useState<boolean>(
		JSON.parse(
			sessionStorage.getItem(WORKSPACE_INDICATOR_TOAST_FIELD) || 'false',
		),
	);

	const handleClose = () => {
		setIsManuallyClosed(isManuallyClosed);
		sessionStorage.setItem(WORKSPACE_INDICATOR_TOAST_FIELD, 'false');
	};

	const handleOpen = () => {
		setIsManuallyClosed(false);
		sessionStorage.setItem(WORKSPACE_INDICATOR_TOAST_FIELD, 'true');
	};

	const isGoodkindAdmin = useMemo(() => {
		const isGKAdmin = checkIsGKAdmin(userEmail);
		return isGKAdmin;
	}, [userEmail]);

	useEffect(() => {
		const lastOrganizationName = localStorage.getItem('lastOrganizationName');

		if (isGoodkindAdmin && organizationName) {
			if (
				organizationName &&
				organizationName !== lastOrganizationName &&
				!isManuallyClosed
			) {
				showToast({
					toastId: 'workspace-indicator-toast',
					type: 'warning',
					message: `Viewing ${organizationName} Workspace`,
					textColor: 'system.text.default',
					showIcon: false,
					onClose: handleClose,
					onOpen: handleOpen,
					autoClose: false,
					closeButton: true,
				});
				localStorage.setItem('lastOrganizationName', organizationName);
			}
		}
	}, [organizationName, isManuallyClosed]);
	return null;
}
